import { apiFetch } from '@/shared/api/client'

export type PinLoginRequest = {
  device_id: string
  pin: string
}

/** Satu endpoint untuk tablet & delman — device_type sudah terikat ke device_id di server. */
export type PinLoginResponse = {
  access_token: string
  user: {
    id: string
    name: string
    role_code: string
  }
  brand_id: string
  brand_code: string
  warehouse_id?: string
  authority: 'full' | 'attendance_only'
  head_present: boolean
}

export async function loginPin(req: PinLoginRequest): Promise<PinLoginResponse> {
  return apiFetch<PinLoginResponse>('/auth/pin-login', {
    method: 'POST',
    body: JSON.stringify(req),
  })
}
